import { render, staticRenderFns } from "./by-product.vue?vue&type=template&id=56c2d23a"
import script from "./by-product.vue?vue&type=script&lang=js"
export * from "./by-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports